import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './LoginCTASection.css';

/**
 * Login CTA Section Component
 * 
 * Displays enticing login prompts for non-authenticated users
 * Matches the iPad app design with "Pick up right where you left off" messaging
 * Uses identical styling to CategoryRail headers for seamless integration
 */
const LoginCTASection = ({ 
  sectionTitle,
  title = "Pick up right where you left off.",
  subtitle = "Login now to watch again your favorite series & movies."
}) => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search }
    });
  };

  return (
    <div className="login-cta-section">
      {/* Section Title - Match CategoryRail header styling exactly */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-bold text-white">
          {sectionTitle}
        </h2>
      </div>

      {/* CTA Content */}
      <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
        <div className="max-w-md mx-auto">
          {/* Main Title */}
          <h3 className="text-xl md:text-2xl font-semibold text-white mb-4 leading-tight">
            {title}
          </h3>
          
          {/* Subtitle */}
          <p className="text-gray-300 mb-8 text-base md:text-lg leading-relaxed">
            {subtitle}
          </p>
          
          {/* Login Button */}
          <button
            onClick={handleLogin}
            className="bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-200 text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform"
          >
            Login & Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginCTASection;
